export default "https://assets.pclncdn.com/web/next-landing/01bc7bc/_next/static/images/marketing-tout-3f2bcb795a32a37449d9217f566105d1.webp";